import React, { Component, Fragment } from "react";
import { classNamesPrefixed } from "../../../helpers/CoreHelpers";
import Collapsible from "react-collapsible";
import { collapsibleSettings } from "../../helpers/Helpers";
import ImageField from "./ImageField";
import InputField from "./InputField";
import InputWrap from "./InputWrap";
import SelectField from "./SelectField";
import CONSTANTS from "../../config/constants";

// variants differentiated by key property in DB
const HeroVariants = Object.freeze({
  LearnerHome: "HeroLearnerHome",
});

class HeroField extends Component {
  onChangeTitle = (e) => {
    const { input } = this.props;

    input.onChange({
      ...input.value,
      title: e.target.value,
    });
  };

  onChangeSearchEngine = (e) => {
    const { input } = this.props;
    const { value } = e.target;

    input.onChange({
      ...input.value,
      searchEngine: value,
    });
  };

  onChangeImage = (image) => {
    const { input } = this.props;

    input.onChange({
      ...input.value,
      image: image,
    });
  };

  onChangeOpacity = (opacity) => {
    const { input } = this.props;

    input.onChange({
      ...input.value,
      opacity,
    });
  };

  render() {
    const {
      input,
      label,
      omitCollapsible,
      expanded,
      pageTitle,
      fieldKey,
    } = this.props;

    const defaultValue = 100;
    const altHero = Object.values(HeroVariants).some((o) => o === fieldKey);

    const searchEngineLabel = (
      <span>
        <b>Search engine</b>
        <span
          className={classNamesPrefixed({ info__label: true })}
          data-tip="The <b>placeholder</b> text to display"
          data-for="help-text-tooltip"
        />
      </span>
    );

    const content = (
      <InputWrap {...this.props} label={null}>
        <InputField
          {...this.props}
          label={
            <span>
              <b>Title</b>
              <span
                className={classNamesPrefixed({ info__label: true })}
                data-tip={`<b>Hero title</b> appears on the hero of the ${pageTitle ||
                  "page"}`}
                data-for="help-text-tooltip"
              ></span>
            </span>
          }
          input={{
            value: input.value.title ? input.value.title : "",
            onChange: this.onChangeTitle,
          }}
          omitCollapsible={true}
        />
        <br />
        <label className={classNamesPrefixed({ field__label: true })}>
          Image
        </label>
        <ImageField
          {...this.props}
          title={"Image"}
          input={{
            value: input.value.image ? input.value.image : "",
            onChange: this.onChangeImage,
          }}
          omitCollapsible={true}
        />
        <br />
        <SelectField
          label={"Opacity"}
          defaultValue={
            input.value.opacity
              ? CONSTANTS.OPACITY_DROPDOWN.find(
                  (a) => a.id === input.value.opacity
                )
              : CONSTANTS.OPACITY_DROPDOWN.find((a) => a.id === defaultValue)
          }
          omitCollapsible={true}
          afterOnChange={(opacity) => {
            this.onChangeOpacity(opacity);
          }}
          items={CONSTANTS.OPACITY_DROPDOWN}
          classes="field--opacity"
        />
        {altHero && (
          <Fragment>
            <br />
            <InputField
              {...this.props}
              label={searchEngineLabel}
              input={{
                value: input.value.searchEngine || "Search here...",
                onChange: this.onChangeSearchEngine,
                omitCollapsible: true,
              }}
            />
          </Fragment>
        )}
      </InputWrap>
    );

    return (
      <Fragment>
        {omitCollapsible ? (
          <div>{content}</div>
        ) : (
          <Collapsible
            {...collapsibleSettings}
            trigger={
              <label className={classNamesPrefixed({ trigger__label: true })}>
                {label ? label : "Hero field"}
              </label>
            }
            open={expanded}
          >
            {content}
          </Collapsible>
        )}
      </Fragment>
    );
  }
}

export default HeroField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/HeroField.js